import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Camera, Upload, ArrowRight } from 'lucide-react';
import { useLocation } from "wouter";

export default function PhotoUploadFlow() {
  const [, navigate] = useLocation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Camera className="h-12 w-12 text-blue-600" />
            <h1 className="text-4xl font-bold text-gray-800">Photo Upload System</h1>
          </div>
          <p className="text-lg text-gray-600">
            Sistema completo de upload e processamento de fotos de eventos esportivos
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Photo Selector Card */}
          <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => navigate('/photo-selector')}>
            <CardHeader className="text-center">
              <div className="flex items-center justify-center mb-2">
                <Upload className="h-8 w-8 text-blue-600" />
              </div>
              <CardTitle className="text-xl">1. Seletor de Fotos</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-gray-600 text-center">
                Selecione múltiplas imagens, configure evento e categoria, e execute pré-processamento em lote.
              </p>
              <div className="space-y-2 text-sm text-gray-500">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>Upload múltiplo de imagens</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>Seleção de evento</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>Pré-processamento em lote</span>
                </div>
              </div>
              <Button className="w-full" onClick={() => navigate('/photo-selector')}>
                Iniciar Upload
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </CardContent>
          </Card>

          {/* Photo Viewer Card */}
          <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => navigate('/photo-viewer')}>
            <CardHeader className="text-center">
              <div className="flex items-center justify-center mb-2">
                <Camera className="h-8 w-8 text-green-600" />
              </div>
              <CardTitle className="text-xl">2. Visualizador de Fotos</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-gray-600 text-center">
                Visualize, edite metadados e navegue entre as fotos processadas antes do upload final.
              </p>
              <div className="space-y-2 text-sm text-gray-500">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span>Navegação entre fotos</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span>Edição de metadados</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span>Controles de zoom</span>
                </div>
              </div>
              <Button variant="outline" className="w-full" onClick={() => navigate('/photo-viewer')}>
                Abrir Visualizador
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </CardContent>
          </Card>
        </div>

        <div className="mt-8 text-center">
          <div className="flex items-center justify-center gap-4 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-semibold">1</span>
              </div>
              <span>Selecionar Fotos</span>
            </div>
            <ArrowRight className="h-4 w-4" />
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 font-semibold">2</span>
              </div>
              <span>Processar & Upload</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}